import SectionHeading from "@/pages/home/components/SectionHeading";
import { equipments } from "@/mocks/about";

export default function Equipment() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-6xl mx-auto flex flex-col gap-12">
        <SectionHeading
          eyebrow="Equipment"
          title="비앙카의 관리 장비"
          description="검증된 최신 장비로 관리 효과를 한층 높여드립니다."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {equipments.map((equipment) => (
            <div
              key={equipment.id}
              className="flex items-start gap-4 p-6 rounded-2xl bg-background-50 border border-background-200/70 transition-all hover:border-primary-200 hover:bg-primary-50/40 cursor-pointer"
            >
              <span className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center shrink-0">
                <i className={`${equipment.icon} text-2xl text-accent-600`}></i>
              </span>
              <div className="flex flex-col gap-1.5">
                <h3 className="text-base font-semibold text-foreground-900">{equipment.name}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{equipment.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}